// Custom components
import useApi from '@/lib/api/useApi';

// Types
import { IApiResponse } from '@/@types/lib/api';

export type SimulacijaTip = 'zatvaranje' | 'curenje';

export type Simulacija = {
  id: number;
  naziv: string;
  tip: SimulacijaTip;
  ventil_ids: number[];
  wkt: string | null; // leak point, EPSG:3857
  is_global: boolean;
  is_mine: boolean;
  created_on: string;
  modified_on: string | null;
};

type FeatureCollection<P> = {
  type: 'FeatureCollection';
  features: { type: 'Feature'; geometry: object; properties: P }[];
};

export type PotrosacProps = {
  id: number;
  kupac_id: number | null;
  naziv: string | null;
  naselje: string | null;
  ulica: string | null;
  kucni_broj: string | null;
  stan: number | null;
  aktivan: boolean | null;
  kategorija: string | null;
};

export type SimulacijaRezultat = {
  id: number;
  naziv: string;
  tip: SimulacijaTip;
  summary: {
    potrosaci: number;
    potrosaci_aktivni: number;
    plinovodi_m: number;
    ventili: number;
    mrs: number;
  };
  plinovodi: FeatureCollection<{ id: number; duljina_m: number; promjer: number | null; materijal: string | null; vrsta: string | null }>;
  potrosaci: FeatureCollection<PotrosacProps>;
  ventili: FeatureCollection<{ id: number; needed: boolean | null; in_graph: boolean }>;
  mrs: FeatureCollection<{ id: number }>;
};

export type SimulacijaSave = {
  naziv: string;
  ventil_ids?: number[];
  wkt?: string | null;
};

export interface IPlinService {
  getSimulacije: () => Promise<IApiResponse>;
  insertSimulacija: (data: SimulacijaSave & { tip: SimulacijaTip }) => Promise<IApiResponse>;
  updateSimulacija: (id: number, data: SimulacijaSave) => Promise<IApiResponse>;
  deleteSimulacija: (id: number) => Promise<IApiResponse>;
  getRezultat: (id: number) => Promise<IApiResponse>;
}

const getSimulacije = () => useApi().get('plin/simulacije-ventila');

const insertSimulacija = (data: SimulacijaSave & { tip: SimulacijaTip }) => useApi().post('plin/simulacije-ventila', data);

const updateSimulacija = (id: number, data: SimulacijaSave) => useApi().put(`plin/simulacije-ventila/${id}`, data);

const deleteSimulacija = (id: number) => useApi().remove(`plin/simulacije-ventila/${id}`, {});

const getRezultat = (id: number) => useApi().get(`plin/simulacije-ventila/${id}/rezultat`);

export const plinService: IPlinService = {
  getSimulacije,
  insertSimulacija,
  updateSimulacija,
  deleteSimulacija,
  getRezultat,
};
